import React from 'react';

/*
 * Button — canonical, token-driven button primitive.
 *
 * One vocabulary across the app (see .btn-* in App.css):
 *   primary   → navy fill (workhorse / default)
 *   secondary → white surface + neutral border
 *   ghost     → transparent until hover
 *   danger    → red
 *   accent    → gold; reserved for a genuine CTA only (use sparingly)
 *   whatsapp  → external brand action
 *
 * Every variant already ships default / hover / focus / active / disabled
 * states from the global classes, so this just maps a variant prop to a class.
 */
const VARIANT_CLASS = {
  primary: 'btn-navy',
  secondary: 'btn-outline',
  ghost: 'btn-ghost',
  danger: 'btn-danger',
  accent: 'btn-gold',
  whatsapp: 'btn-whatsapp',
};

export default function Button({
  variant = 'primary',
  size,
  type = 'button',
  className = '',
  children,
  ...props
}) {
  const cls = [
    'btn',
    VARIANT_CLASS[variant] || VARIANT_CLASS.primary,
    size === 'sm' ? 'btn-sm' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={cls} {...props}>
      {children}
    </button>
  );
}
